// Les boutons « Se faire plaisir », partagés par l'écran du job d'été et le tableau de bord.
import { PLEASURE_LABEL, TREATS } from '../content/treats';
import { fmtEur, fmtEurPrecise, fmtPoints } from '../engine/format';
import { t } from '../engine/i18n';
import type { GameState } from '../engine/state';
import { update } from '../engine/store';
import { buyTreat, inSummer, treatBonus, treatPrice } from '../game/treats';

export function TreatsPanel({ state }: { state: GameState }) {
  return (
    <>
      <h3 class="subtitle">{t('treats.title')}</h3>
      <div class="choices">
        {TREATS.map((treat) => {
          const price = treatPrice(state, treat);
          return (
            <button key={treat.id} disabled={state.cash < price} onClick={() => update((s) => buyTreat(s, treat.id))}>
              {t('treats.button', {
                title: t(treat.title),
                // Les centimes montrent la hausse des prix dès le premier bilan.
                price: Number.isInteger(price) ? fmtEur(price) : fmtEurPrecise(price),
                bonus: fmtPoints(treatBonus(state, treat)),
              })}
              <small>{t(PLEASURE_LABEL[treat.category])}</small>
            </button>
          );
        })}
      </div>
      <p class="hint">{t(inSummer(state) ? 'treats.hintSummer' : 'treats.hint')}</p>
    </>
  );
}
